import React, { useState } from "react";
import {
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  Spinner,
} from "reactstrap";
import axiosInstance from "../../Request";
import { URL } from "../../api";
import { saveAs } from "file-saver";

const LoanMasterReporting = () => {

  const [loanId, setLoanId] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(false);

  /* ---------------- DOWNLOAD EXCEL ---------------- */
  const downloadLoanMasterExcel = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const params = new URLSearchParams();
      if (loanId) params.append("loanId", loanId);
      if (fromDate) params.append("fromDate", fromDate);
      if (toDate) params.append("toDate", toDate);

      const response = await axiosInstance.get(
        `${URL.Loan_Master_Reporting}?${params.toString()}`,
        {
          responseType: "blob", // 🔴 IMPORTANT
        }
      );

      saveAs(
        response.data,
        `Loan_Master_Report_${new Date().toISOString().slice(0, 10)}.xlsx`
      );
    } catch (error) {
      console.error("Loan Master Excel download failed:", error);
      alert("Failed to download Loan Master report");
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- STYLES ---------------- */
  const font12 = { fontSize: "10px" };
  const inputSmStyle = { ...font12, height: "30px", padding: "2px 6px" };
  const buttonSmStyle = {
    ...font12,
    padding: "4px 12px",
    height: "30px",
  };

  return (
    <div style={font12}>

      <Form onSubmit={downloadLoanMasterExcel} className="mb-3">
        <div
          className="d-flex align-items-end flex-wrap"
          style={{ gap: "10px" }}
        >

          {/* Loan ID */}
          <FormGroup className="mb-0">
            <Label className="fw-bold">Loan ID</Label>
            <Input
              bsSize="sm"
              value={loanId}
              onChange={(e) => setLoanId(e.target.value)}
              placeholder="Enter Loan ID"
              style={inputSmStyle}
            />
          </FormGroup>

          {/* From Date */}
          <FormGroup className="mb-0">
            <Label className="fw-bold">From Date</Label>
            <Input
              bsSize="sm"
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              style={inputSmStyle}
            />
          </FormGroup>

          {/* To Date */}
          <FormGroup className="mb-0">
            <Label className="fw-bold">To Date</Label>
            <Input
              bsSize="sm"
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              style={inputSmStyle}
            />
          </FormGroup>

          {/* Download Button */}
          <div className="d-flex mb-0">
            <Button
              color="success"
              type="submit"
              style={buttonSmStyle}
              disabled={loading}
            >
              {loading ? (
                <>
                  <Spinner size="sm" /> Downloading...
                </>
              ) : (
                "Download Excel"
              )}
            </Button>
          </div>

        </div>
      </Form>
    </div>
  );
};

export default LoanMasterReporting;
